document.addEventListener('DOMContentLoaded', function () {

  // ── Header scroll effect
  const header = document.getElementById('site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('scrolled', window.scrollY > 40);
    });
  }

  // ── Mobile hamburger menu
  const hamburger = document.getElementById('hamburger');
  const mobileMenu = document.getElementById('mobile-menu');
  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', () => {
      mobileMenu.classList.toggle('open');
      const isOpen = mobileMenu.classList.contains('open');
      hamburger.setAttribute('aria-expanded', isOpen);
    });
  }

  // ── Add to cart AJAX
  document.querySelectorAll('.product-card-form').forEach(form => {
    if (form.tagName !== 'FORM') return;
    form.addEventListener('submit', async function (e) {
      e.preventDefault();
      const btn = form.querySelector('.product-add-btn');
      const originalText = btn.textContent;
      btn.textContent = 'Adding…';
      btn.disabled = true;
      try {
        const formData = new FormData(form);
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          body: formData
        });
        if (response.ok) {
          const item = await response.json();
          showToast(`✓ ${item.product_title} added`);
          updateCartCount();
        } else {
          showToast('Could not add. Please try again.');
        }
      } catch (err) {
        showToast('Something went wrong.');
      }
      btn.textContent = originalText;
      btn.disabled = false;
    });
  });

  // ── Variant selector
  document.querySelectorAll('.variant-btn').forEach(btn => {
    btn.addEventListener('click', function () {
      const position = this.dataset.option;
      document.querySelectorAll(`.variant-btn[data-option="${position}"]`)
        .forEach(b => b.classList.remove('active'));
      this.classList.add('active');
    });
  });

  // ── Toast
  function showToast(message) {
    const toast = document.getElementById('toast');
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('show');
    setTimeout(() => toast.classList.remove('show'), 3000);
  }

  // ── Cart count
  async function updateCartCount() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      const badge = document.querySelector('.cart-count');
      if (cart.item_count > 0) {
        if (badge) {
          badge.textContent = cart.item_count;
        } else {
          const cartIcon = document.querySelector('.cart-icon');
          if (cartIcon) {
            const span = document.createElement('span');
            span.className = 'cart-count';
            span.textContent = cart.item_count;
            cartIcon.appendChild(span);
          }
        }
      }
    } catch (e) {}
  }

  // ── Waitlist
  const waitlistPopup = document.getElementById('waitlist-popup');
  if (waitlistPopup) {
    const wlForm = document.getElementById('waitlist-form');
    const wlSuccess = document.getElementById('waitlist-success');
    const wlEmail = document.getElementById('waitlist-email');
    const wlTitleField = document.getElementById('waitlist-product-title');
    const wlHandleField = document.getElementById('waitlist-product-handle');
    const wlNameSpans = waitlistPopup.querySelectorAll('.waitlist-product-name');
    const companyId = waitlistPopup.dataset.klaviyoCompany;
    const listId = waitlistPopup.dataset.klaviyoList;

    function openWaitlist(title, handle) {
      wlTitleField.value = title || '';
      wlHandleField.value = handle || '';
      wlNameSpans.forEach(s => { if (title) s.textContent = title; });
      wlForm.style.display = '';
      wlSuccess.style.display = 'none';
      waitlistPopup.style.display = 'flex';
      setTimeout(() => wlEmail.focus(), 100);
    }
    function closeWaitlist() { waitlistPopup.style.display = 'none'; }

    document.querySelectorAll('.waitlist-trigger').forEach(btn => {
      btn.addEventListener('click', () => {
        openWaitlist(btn.dataset.productTitle, btn.dataset.productHandle);
      });
    });

    const wlClose = document.getElementById('waitlist-close');
    if (wlClose) wlClose.addEventListener('click', closeWaitlist);
    waitlistPopup.addEventListener('click', (e) => {
      if (e.target === waitlistPopup) closeWaitlist();
    });

    wlForm.addEventListener('submit', async function (e) {
      e.preventDefault();
      const email = wlEmail.value.trim();
      if (!email) return;
      const submitBtn = wlForm.querySelector('.waitlist-submit');
      const originalText = submitBtn.textContent;
      submitBtn.disabled = true;
      submitBtn.textContent = '…';

      const productTitle = wlTitleField.value;

      // 1) Log as an event in Klaviyo (uses the existing onsite integration)
      if (window._learnq) {
        window._learnq.push(['identify', { '$email': email }]);
        window._learnq.push(['track', 'Wachtlijst Aanmelding', { 'Product': productTitle }]);
      }

      // 2) Add to the Klaviyo list so they can be emailed later
      try {
        if (companyId && listId && listId.indexOf('PLAK') === -1) {
          await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + companyId, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
            body: JSON.stringify({
              data: {
                type: 'subscription',
                attributes: {
                  custom_source: 'Wachtlijst',
                  profile: {
                    data: {
                      type: 'profile',
                      attributes: {
                        email: email,
                        properties: { 'Wachtlijst Product': productTitle }
                      }
                    }
                  }
                },
                relationships: { list: { data: { type: 'list', id: listId } } }
              }
            })
          });
        }
      } catch (err) { /* event already logged; fail silently */ }

      wlForm.style.display = 'none';
      wlSuccess.style.display = '';
      submitBtn.disabled = false;
      submitBtn.textContent = originalText;
    });
  }

  // ── Scroll fade-up
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12 });

  document.querySelectorAll('.product-card, .give-block, .value-item, .impact-stat').forEach(el => {
    el.style.opacity = '0';
    el.style.transform = 'translateY(20px)';
    el.style.transition = 'opacity 0.6s ease, transform 0.6s cubic-bezier(0.22,1,0.36,1)';
    observer.observe(el);
  });

  // ── Announce bar rotation
  const slides = document.querySelectorAll('.announce-slide');
  let current = 0;
  if (slides.length > 1) {
    setInterval(() => {
      slides[current].classList.remove('active');
      current = (current + 1) % slides.length;
      slides[current].classList.add('active');
    }, 5000);
  }

  // Gift wrap
  window.toggleGiftWrap = function(checkbox) {
    const giftWrapId = '{{ all_products["cadeau-verpakking"].variants.first.id }}';
    if (checkbox.checked) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({id: giftWrapId, quantity: 1})
      }).then(() => updateCartCount());
    } else {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({id: giftWrapId, quantity: 0})
      }).then(() => updateCartCount());
    }
  };

});
window.switchMedia = function (index, btn) {
  var items = document.querySelectorAll('#gallery-main .gallery-media');
  items.forEach(function (el, i) {
    if (i === index) {
      el.classList.add('active');
    } else {
      el.classList.remove('active');
      var v = el.querySelector('video');
      if (v) { v.pause(); }
    }
  });
  document.querySelectorAll('.product-gallery-thumbs .thumb-btn')
    .forEach(function (b) { b.classList.remove('active'); });
  if (btn) { btn.classList.add('active'); }
};
document.addEventListener('DOMContentLoaded', function () {
  var el = document.querySelector('.presale-countdown');
  if (!el) return;
  var deadline = new Date(el.getAttribute('data-deadline')).getTime();
  var dEl = el.querySelector('[data-days]'), hEl = el.querySelector('[data-hours]'),
      mEl = el.querySelector('[data-mins]'), sEl = el.querySelector('[data-secs]');
  function pad(n){ return (n < 10 ? '0' : '') + n; }
  var timer = setInterval(function () {
    var diff = deadline - Date.now();
    if (diff <= 0) {
      el.innerHTML = '<span class="countdown-label">Pre-order closed</span>';
      clearInterval(timer); return;
    }
    dEl.textContent = pad(Math.floor(diff / 86400000));
    hEl.textContent = pad(Math.floor((diff % 86400000) / 3600000));
    mEl.textContent = pad(Math.floor((diff % 3600000) / 60000));
    sEl.textContent = pad(Math.floor((diff % 60000) / 1000));
  }, 1000);
});